(function (window, document) {
	'use strict';

	var $ = window.jQuery;
	var bs = window.bootstrap || null;

	if (!$) {
		return;
	}

	function trigger($element, eventName, relatedTarget) {
		var event = $.Event(eventName);

		if (relatedTarget) {
			event.relatedTarget = relatedTarget;
		}

		$element.trigger(event);
		return event;
	}

	function getSelector($trigger) {
		return (
			$trigger.attr('data-bs-target') ||
			$trigger.attr('data-target') ||
			$trigger.attr('href')
		);
	}

	function getElementFromTrigger($trigger) {
		var selector = getSelector($trigger);

		if (!selector || selector.charAt(0) !== '#') {
			return null;
		}

		return document.querySelector(selector);
	}

	function getComponent(name) {
		return bs && bs[name] ? bs[name] : null;
	}

	function showFallbackModal($modal, relatedTarget) {
		if (!$modal.length || $modal.hasClass('in')) {
			return;
		}

		var showEvent = trigger($modal, 'show.bs.modal', relatedTarget);

		if (showEvent.isDefaultPrevented()) {
			return;
		}

		var $backdrop = $(
			'<div class="modal-backdrop fade in bootstrap-wdt-backdrop"></div>'
		);

		$('body').append($backdrop).addClass('modal-open');

		$modal
			.show()
			.scrollTop(0)
			.attr('aria-hidden', 'false')
			.addClass('in');

		trigger($modal, 'shown.bs.modal', relatedTarget);
	}

	function hideFallbackModal($modal, relatedTarget) {
		if (!$modal.length || !$modal.hasClass('in')) {
			return;
		}

		var hideEvent = trigger($modal, 'hide.bs.modal', relatedTarget);

		if (hideEvent.isDefaultPrevented()) {
			return;
		}

		$modal.removeClass('in').attr('aria-hidden', 'true').hide();
		$('.bootstrap-wdt-backdrop').remove();
		$('body').removeClass('modal-open');

		trigger($modal, 'hidden.bs.modal', relatedTarget);
	}

	function activateFallbackTab($trigger) {
		var selector = getSelector($trigger);

		if (!selector || selector.charAt(0) !== '#') {
			return;
		}

		var $tabPane = $(selector);

		if (!$tabPane.length) {
			return;
		}

		var $listItem = $trigger.closest('li');
		var $tabList = $listItem.parent();
		var $activeTrigger = $tabList
			.find(
				'li.active > [data-toggle="tab"], li.active > [data-toggle="pill"]'
			)
			.first();
		var $activePane = $();

		if ($activeTrigger.length) {
			$activePane = $($(getSelector($activeTrigger)));
		}

		if ($activeTrigger[0] === $trigger[0]) {
			return;
		}

		var hideEvent = $activeTrigger.length
			? trigger($activeTrigger, 'hide.bs.tab', $trigger[0])
			: null;
		var showEvent = trigger($trigger, 'show.bs.tab', $activeTrigger[0]);

		if (
			(hideEvent && hideEvent.isDefaultPrevented()) ||
			showEvent.isDefaultPrevented()
		) {
			return;
		}

		$tabList.find('li').removeClass('active');
		$listItem.addClass('active');

		if ($activePane.length) {
			$activePane.removeClass('active in show');
			trigger($activeTrigger, 'hidden.bs.tab', $trigger[0]);
		}

		$tabPane.addClass('active in show');
		trigger($trigger, 'shown.bs.tab', $activeTrigger[0]);
	}

	function toggleFallbackDropdown($trigger) {
		var $parent = $trigger.closest('.dropdown');

		if (!$parent.length) {
			return;
		}

		var isOpen = $parent.hasClass('open');

		$('.dropdown.open').not($parent).removeClass('open');
		$parent.toggleClass('open', !isOpen);
		$trigger.attr('aria-expanded', String(!isOpen));
	}

	function toggleFallbackCollapse($trigger) {
		var $target = $(getSelector($trigger));

		if (!$target.length) {
			return;
		}

		var isShown = $target.hasClass('in');

		$target.toggleClass('in show', !isShown);
		$trigger.attr('aria-expanded', String(!isShown));
	}

	function modalAction(element, action, relatedTarget) {
		var Modal = getComponent('Modal');

		if (Modal) {
			var instance = Modal.getOrCreateInstance(element);

			if (action === 'hide') {
				instance.hide();
			} else if (action === 'toggle') {
				instance.toggle();
			} else {
				instance.show(relatedTarget);
			}

			return;
		}

		if (action === 'hide') {
			hideFallbackModal($(element), relatedTarget);
			return;
		}

		if (action === 'toggle' && $(element).hasClass('in')) {
			hideFallbackModal($(element), relatedTarget);
			return;
		}

		showFallbackModal($(element), relatedTarget);
	}

	function tabAction(element) {
		var Tab = getComponent('Tab');

		if (Tab) {
			Tab.getOrCreateInstance(element).show();
			return;
		}

		activateFallbackTab($(element));
	}

	function dropdownAction(element) {
		var Dropdown = getComponent('Dropdown');

		if (Dropdown) {
			Dropdown.getOrCreateInstance(element).toggle();
			return;
		}

		toggleFallbackDropdown($(element));
	}

	function collapseAction(element, action) {
		var target =
			element.classList.contains('collapse') || element.classList.contains('collapsing')
				? element
				: getElementFromTrigger($(element));
		var Collapse = getComponent('Collapse');

		if (!target) {
			return;
		}

		if (Collapse) {
			var instance = Collapse.getOrCreateInstance(target, { toggle: false });

			if (action === 'hide') {
				instance.hide();
			} else if (action === 'show') {
				instance.show();
			} else {
				instance.toggle();
			}

			return;
		}

		toggleFallbackCollapse($(element));
	}

	if (!$.fn.modal) {
		$.fn.modal = function (action) {
			return this.each(function () {
				modalAction(this, action, document.activeElement);
			});
		};
	}

	if (!$.fn.tab) {
		$.fn.tab = function (action) {
			return this.each(function () {
				if (action === 'show') {
					tabAction(this);
				}
			});
		};
	}

	if (!$.fn.dropdown) {
		$.fn.dropdown = function (action) {
			return this.each(function () {
				if (!action || action === 'toggle') {
					dropdownAction(this);
				}
			});
		};
	}

	if (!$.fn.collapse) {
		$.fn.collapse = function (action) {
			return this.each(function () {
				collapseAction(this, action || 'toggle');
			});
		};
	}

	$.fn.modal.Constructor = $.fn.modal.Constructor || getComponent('Modal') || function () {};
	$.fn.tab.Constructor = $.fn.tab.Constructor || getComponent('Tab') || function () {};
	$.fn.dropdown.Constructor =
		$.fn.dropdown.Constructor || getComponent('Dropdown') || function () {};
	$.fn.collapse.Constructor =
		$.fn.collapse.Constructor || getComponent('Collapse') || function () {};

	$(document).on('click', '[data-toggle="modal"]', function (event) {
		var target = getElementFromTrigger($(this));

		if (!target) {
			return;
		}

		event.preventDefault();
		modalAction(target, 'show', this);
	});

	$(document).on(
		'click',
		'[data-dismiss="modal"], [data-bs-dismiss="modal"]',
		function (event) {
		var modalElement = $(this).closest('.modal')[0];

		if (!modalElement) {
			return;
		}

		event.preventDefault();
		modalAction(modalElement, 'hide', this);
		}
	);

	$(document).on('click', '[data-toggle="tab"], [data-toggle="pill"]', function (event) {
		event.preventDefault();
		tabAction(this);
	});

	$(document).on('click', '[data-toggle="dropdown"]', function (event) {
		event.preventDefault();
		dropdownAction(this);
	});

	$(document).on('click', '[data-toggle="collapse"]', function (event) {
		event.preventDefault();
		collapseAction(this, 'toggle');
	});

	$(document).on('click', '.modal', function (event) {
		if ($(event.target).is('.modal') && !getComponent('Modal')) {
			hideFallbackModal($(this), event.target);
		}
	});

	$(document).on('click', function (event) {
		if (
			!$(event.target).closest('.dropdown').length &&
			!$(event.target).is('[data-toggle="dropdown"]')
		) {
			$('.dropdown.open').removeClass('open');
			$('[data-toggle="dropdown"]').attr('aria-expanded', 'false');
		}
	});

	$(document).on('keydown', function (event) {
		if ((event.key !== 'Escape' && event.keyCode !== 27) || getComponent('Modal')) {
			return;
		}

		hideFallbackModal($('.modal.in').last(), document.activeElement);
	});
})(window, document);
